export default function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
// module id = 383
// module chunks = 0